import { shine } from '@shinetools/invoicing-calculation'

import type { ImportedInvoiceLineAmounts } from '../types/importedInvoiceLineAmounts'

interface GetImportedInvoiceLineAmountsOptions {
  amountExclVat: number | null
  currency: string | null
  /** A fraction, e.g. `0.25`. */
  vatRate: number | null
}

/**
 * Rounded the way the currency is, so the line, the totals and approve all agree. Without a VAT
 * rate the VAT amount is unknown, and the gross amount is the net amount.
 */
export const getImportedInvoiceLineAmounts = (
  options: GetImportedInvoiceLineAmountsOptions,
): ImportedInvoiceLineAmounts => {
  const { amountExclVat, currency, vatRate } = options

  if (amountExclVat === null) {
    return { grossAmount: null, vatAmount: null }
  }

  const { grossTotal, vatAmount } = shine.InvoiceLine.calculate(
    String(amountExclVat),
    '1',
    String(vatRate ?? 0),
    undefined,
    currency ?? undefined,
  )

  return { grossAmount: Number(grossTotal), vatAmount: vatRate === null ? null : Number(vatAmount) }
}
